import React, { useCallback } from 'react';
import '../../assets/stylesheets/Units/Checkbox.scss';

const Checkbox = ({
    className,
    label,
    labelClassName,
    checkboxClassName,
    onChange,
    checked,
}) => {
    const classes = ['checkbox'];
    if (className) classes.push(className);
    if (checked) classes.push('checkbox--checked');

    const labelClasses = labelClassName ? `checkboxLabel ${labelClassName}` : 'checkboxLabel';

    const checkboxClasses = ['checkboxInput'];
    if (checkboxClassName) checkboxClasses.push(checkboxClassName);
    if (checked) checkboxClasses.push('checkboxInput--checked');

    const onClick = useCallback(() => {
        if (onChange) onChange(!checked);
    }, [checked, onChange]);

    return (
        <div className={classes.join(' ')} onClick={onClick}>
            {label ?
                (<span className={labelClasses}>{label}</span>) :
                false
            }
            <div className={checkboxClasses.join(' ')} />
        </div>
    );
}

export default Checkbox;